// --------------------------------------------------------
// Allergies - Allergies
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from "react";
import Colors from "../../../../constants/Colors";
import {
  H1,
  Text,
} from "../../../../components/UI/generalLayout/Layout.styled";
import { ContainerAllergies, HeaderAllergies } from "./Allergies.styled";
import {
  HeaderTable,
  SearchContainer,
  SolidButton,
  Table,
  TBody,
  Title,
  TR,
} from "../attendanceRecord/AttendanceRecord.styled";
import { Spacer } from "../../../../components/UI/spacer/spacer";
import { Button, CircularProgress, OutlinedInput } from "@mui/material";
import useResponsiveInfo from "../../../../hooks/useResponsiveInfo";
import { Search } from "@mui/icons-material";
import CareLineDropdown from "../../../../components/dropdown/CareLineDropdown";
import CardAllergies from "./components/cardAllergies/CardAllergies";
import { useAppDispatch } from "../../../..";
import * as allergiesAction from "../../../../store/actions/allergies";
import { useSelector } from "react-redux";
import { PersonAllergieService } from "../../../../core/http/service/PersonAllergieService";
import { useLocation, useNavigate } from "react-router-dom";
import { Paths } from "../../../../enums/Paths";

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

interface IAllergies {
  pessoa: any;
  setAllergiesColor: any;
}

const allValue = [{ nome: "Todos", id: 0 }];
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.S
 */
const Allergies = ({ pessoa, setAllergiesColor }: IAllergies) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = (state as any) ?? {};
  // --------------------------------------------------------
  // Allergies PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const typesAllergies: [] =
    useSelector((state: any) => state.allergies.types) ?? [];

  const { isMobile } = useResponsiveInfo();
  const [modalAllergies, setModalAllergies] = useState(false);
  const [search, setSearch] = useState("");
  const [searchAlergino, setSearchAlergino] = useState("");
  const [selectedType, setSelectedType] = useState<any>();
  const [allergies, setAllergies] = useState<[]>([]);
  const [error, setError] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const { currentProfile }: any = useSelector((state: any) => state.login);
  const acessoProntuario = useSelector((state: any)=> state.person.acessoProntuario)

  // --------------------------------------------------------

  const fetchTypesAllergies = useCallback(async () => {
    await dispatch(allergiesAction.getTypes());
  }, [dispatch]);

  const fetchAllergies = () => {
    const service = new PersonAllergieService();
    if (pessoa) {
      setLoading(true);
      const selectedAll =
        selectedType?.nome !== "Todos" ? selectedType?.nome : "";

      service
        .getAllergiesPerson({
          id: pessoa.idPessoa,
          alergeno: searchAlergino,
          tipo: selectedAll,
        })
        .then(({ data: { data } }) => {
          setAllergies(data);
          if (selectedAll === undefined && searchAlergino === "") {
            if (data.length > 0) {
              setAllergiesColor(Colors.cancel);
            } else {
              setAllergiesColor(null);
            }
          }
        })
        .catch((error): any => {
          setError([error]);
        })
        .finally(() => setLoading(false));
    }
  };

  const onClickSearch = () => {
    setSearchAlergino(search);
  };

  const dellAllergie = async (id: any) => {
    await dispatch(allergiesAction.deleteAllergiePerson(id));
    fetchAllergies();
  };

  useEffect(() => {
    fetchAllergies();
  }, [searchAlergino, pessoa, selectedType, modalAllergies]);

  useEffect(() => {
    fetchTypesAllergies();
    fetchAllergies();
  }, []);

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerAllergies>
      <HeaderAllergies>
        <H1>Alergias</H1>
        {
          !acessoProntuario ? 
            <SolidButton
            width={21}
            style={{ height: "20px" }}
            color={Colors.SPM600}
            onClick={() =>
              navigate(Paths.RegistrarAlergia, {
                state: { pessoa: pessoa, allergies: allergies },
              })
            }
          >
            Registrar Alergia
          </SolidButton>
          :
            ''
        }

      </HeaderAllergies>
      <Spacer top={20} />
      <SearchContainer>
        <OutlinedInput
          style={{
            borderRadius: "10px",
            width: isMobile ? "70%" : "450px",
          }}
          id="outlined-adornment-amount"
          endAdornment={
            <Button onClick={onClickSearch}>
              <Search />
            </Button>
          }
          label=""
          placeholder="Buscar alérgeno"
          value={search}
          onChange={(event: any) => {
            setSearch(event.target.value);
          }}
        />
        <CareLineDropdown
          value={selectedType}
          onChange={setSelectedType}
          items={typesAllergies}
          disabled={false}
          backgroundColor={Colors.SPM50}
          textColor={Colors.SPM600}
          placeholder="Selecione o tipo"
          containerStyle={{
            width: isMobile ? "100%" : "25%",
          }}
          allValue={allValue}
        />
      </SearchContainer>
      <Spacer top={30} />
      {loading ? (
        <div
          style={{
            textAlign: "center",
            width: "100%",
            marginTop: 50,
            height: 50,
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <Table id="table">
            <HeaderTable>
              <TR>
                <Title bold>Tipo</Title>
                <Title bold>Alérgeno</Title>
                <Title />
              </TR>
            </HeaderTable>
            <Spacer bottom={10} />
            <TBody>
              {/* Mapping das alergias */}
              {allergies.length > 0 && id ? (
                allergies
                  .filter((d: any) => d.id === id)
                  .map((data, index) => {
                    return (
                      <>
                        <Spacer top={10} />

                        <CardAllergies
                          data={data}
                          key={index}
                          onClickDell={dellAllergie}
                        />
                      </>
                    );
                  })
              ) : allergies.length > 0 ? (
                allergies.map((data, index) => {
                  return (
                    <>
                      <Spacer top={10} />

                      <CardAllergies
                        data={data}
                        key={index}
                        onClickDell={dellAllergie}
                      />
                    </>
                  );
                })
              ) : (
                <Text>Nenhum resultado encontrado</Text>
              )}
            </TBody>
          </Table>
        </>
      )}
    </ContainerAllergies>
  );
  // --------------------------------------------------------
};

export default Allergies;
